import { BREADCRUMB } from '../constants/staticText'

// Der Weg zur aktuellen Seite, nach dem Muster von eventTrail (Events-App):
// die letzte Station traegt kein Ziel, und Start liegt ausserhalb der
// React-App — ohne die Kennzeichnung wuerde react-router '/' als App-Route
// behandeln und die WordPress-Startseite nie erreichen.
const jobsTrail = (job) => [
    { label: BREADCRUMB.start, to: '/', extern: true },
    job ? { label: BREADCRUMB.jobs, to: '/stellenangebote/' } : { label: BREADCRUMB.jobs },
    ...job ? [{ label: job.title }] : []
]

export default jobsTrail
